'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debounce = require('./src/debounce');

Object.defineProperty(exports, 'debounce', {
  enumerable: true,
  get: function get() {
    return _debounce.debounce;
  }
});

var _throttle = require('./src/throttle');

Object.defineProperty(exports, 'throttle', {
  enumerable: true,
  get: function get() {
    return _throttle.throttle;
  }
});

var _fireEvent = require('./src/fire-event');

Object.defineProperty(exports, 'fireEvent', {
  enumerable: true,
  get: function get() {
    return _fireEvent.fireEvent;
  }
});

var _onPageLoadCompleted = require('./src/on-page-load-completed');

Object.defineProperty(exports, 'onPageLoadComplete', {
  enumerable: true,
  get: function get() {
    return _onPageLoadCompleted.onPageLoadComplete;
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nimius/event-utility/index.js
// module id = 58
// module chunks = 5